import { Injectable } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { observable, Observable, of, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.state';
import { AddressInfoService } from './address-info.service';
import { ContactInfoService } from './contact-info.service';
import { selectContact } from 'src/app/state/selectors/contact-model.selectors';
import { RegionalSettingsService } from './regional-settings.service';
import { isStringNullOrWhiteSpace } from 'src/app/util/StringUtil';

@Injectable({
  providedIn: 'root'
})
export class DropdownValueService {

  public static genderIds: SelectItem[] = new Array<SelectItem>();

  public static preferedChannels: SelectItem[] = new Array<SelectItem>();

  private static addressService: AddressInfoService;
  private static contactService: ContactInfoService;
  private static regionalService: RegionalSettingsService;
  private static store: Store<AppState>;

  private static salutationValues: SelectItem[] = new Array<SelectItem>();

  private static streetDirectionValues: SelectItem[] = new Array<SelectItem>();

  private static streetSuffixValues: SelectItem[] = new Array<SelectItem>();

  private static unitTypes: SelectItem[] = new Array<SelectItem>();

  private static streetTypeValues: SelectItem[] = new Array<SelectItem>();

  public static countryValues: SelectItem[] = new Array<SelectItem>();

  private static stateValues: SelectItem[] = new Array<SelectItem>();
  private static stateRegion: string;
  private static defaultRegion: string;

  private static ethniticityValues: SelectItem[] = new Array<SelectItem>();

  public static addressTypes: SelectItem[] = new Array<SelectItem>();

  private static subdivisionValues: SelectItem[] = new Array<SelectItem>();

  private static securityTemplates: SelectItem[] = [
    {
      label: 'To what city did you go the first time you flew on a plane?',
      value: 'To what city did you go the first time you flew on a plane?'
    },
    { label: 'What is the first name of the person you first kissed?', value: 'What is the first name of the person you first kissed?' },
    {
      label: 'What was the last name of your favorite childhood teacher?',
      value: 'What was the last name of your favorite childhood teacher?'
    },
    { label: 'In what city or town does your nearest sibling live?', value: 'In what city or town does your nearest sibling live?' },
    { label: 'In what town or city was your first full time job?', value: 'In what town or city was your first full time job?' },
    { label: 'What was your favorite food as a child?', value: 'What was your favorite food as a child?' }
  ];

  private DropdownValueRepo = {
    ddlAddressType: this.getAddressTypes,
    ddlAppSalutation: this.getSalutationValue,
    ddlAppCountry: this.getCountryValues,
    ddlAppState: this.getStateValues,
    ddlBirthplaceState: this.getStateValues,
    ddlBirthplaceCountry: this.getCountryValues,
    ddlCountry: this.getCountryValues,
    ddlDriverLicenseState: this.getStateValues,
    ddlPreferredChannel: this.getPreferedChannels,
    ddlQuestion: this.getSecurityQuestionTemplates,
    ddlRace: this.getEthnicityValues,
    ddlStreetDirection: this.getStreetDirectionValues,
    ddlStreetSuffix: this.getStreetSuffixValues,
    ddlStreetSuffixDirection: this.getStreetDirectionValues,
    ddlStreetType: this.getStreetTypeValues,
    ddlUnitType: this.getUnitTypes,
    ddlQuestionForDaily: this.getSecurityQuestionTemplates,
    radioListAppGender: this.getGenderIdentityValue,
    ddlSubdivision: this.getSubdivisionValues,
    txtState: this.getStateValues,
    txtAppState: this.getStateValues
  };

  constructor(appstore: Store<AppState>, contactInfoService: ContactInfoService, addressInfoService: AddressInfoService, regionalService: RegionalSettingsService) {
    DropdownValueService.addressService = addressInfoService;
    DropdownValueService.contactService = contactInfoService;
    DropdownValueService.regionalService = regionalService;
    DropdownValueService.store = appstore;
    DropdownValueService.regionalService.getDefaultCountry().subscribe(def=> DropdownValueService.defaultRegion = def);
  }

  getDropdownValueFun(controlName: string, key?: string): Observable<SelectItem[]> {
    const resolver = this.DropdownValueRepo[controlName];
    if (resolver) {
      if (key && key !== '') {
        return resolver(key);
      } else {
        return resolver();
      }
    }
    return of(null);
  }

  getRepoValueFunc(controlName: string): Observable<SelectItem[]> {
    return this.DropdownValueRepo[controlName];
  }

  getSalutationValue() {
    if (DropdownValueService.salutationValues.length <= 0) {
      return DropdownValueService.contactService.getSalutationList().pipe(map(res => {
        const arry = res as Array<string>;
        arry.forEach(s => {
          DropdownValueService.salutationValues.push({ label: s, value: s });
        });
        return DropdownValueService.salutationValues;
      }));
    }
    return of(DropdownValueService.salutationValues);

  }
  getStreetDirectionValues() {
    if (DropdownValueService.streetDirectionValues.length <= 0) {
      return DropdownValueService.addressService.getStreetDirectionValues().pipe(map(res => {
        DropdownValueService.streetDirectionValues.length = 0;
        Object.keys(res).forEach(s => {
          DropdownValueService.streetDirectionValues.push({ label: res[s], value: s });
        });
        return DropdownValueService.streetDirectionValues;
      }));
    }
    return of(DropdownValueService.streetDirectionValues);

  }

  getStreetSuffixValues() {
    if (DropdownValueService.streetSuffixValues.length <= 0) {
      return DropdownValueService.addressService.getStreetSuffixValues().pipe(map(res => {
        DropdownValueService.streetSuffixValues.length = 0;
        Object.keys(res).forEach(s => {
          DropdownValueService.streetSuffixValues.push({ label: res[s], value: s });
        });
        return DropdownValueService.streetSuffixValues;
      }));
    }
    return of(DropdownValueService.streetSuffixValues);

  }

  getUnitTypes() {
    if (DropdownValueService.unitTypes.length <= 0) {
      return DropdownValueService.addressService.getUnitTypes().pipe(map(res => {
        DropdownValueService.unitTypes.length = 0;
        Object.keys(res).forEach(s => {
          DropdownValueService.unitTypes.push({ label: res[s], value: s });
        });
        return DropdownValueService.unitTypes;
      }));
    }
    return of(DropdownValueService.unitTypes);
  }
  getStreetTypeValues() {
    if (DropdownValueService.streetTypeValues.length <= 0) {
      return DropdownValueService.addressService.getStreetTypeValues().pipe(map(res => {
        DropdownValueService.streetTypeValues.length = 0;
        Object.keys(res).forEach(s => {
          DropdownValueService.streetTypeValues.push({ label: res[s], value: s });
        });
        return DropdownValueService.streetTypeValues;
      }));
    }
    return of(DropdownValueService.streetTypeValues);

  }
  getPreferedChannels() {
    if (DropdownValueService.preferedChannels.length <= 0) {
      return DropdownValueService.contactService.getPreferredChannel().pipe(map(res => {
        res.forEach(s => {
          DropdownValueService.preferedChannels.push({ label: s.Key, value: s.Value });
        });
        return DropdownValueService.preferedChannels;
      }));
    }
    return of(DropdownValueService.preferedChannels);
  }
  getCountryValues() {
    if (DropdownValueService.countryValues.length <= 0) {
      return DropdownValueService.regionalService.getCountryList().pipe(map(res => {
        res.map(s => {
          DropdownValueService.countryValues.push(s);
        })
        return DropdownValueService.countryValues;
      }));
    }
    return of(DropdownValueService.countryValues);

  }
  getStateValues(countryCode: string) {
    if(isStringNullOrWhiteSpace(countryCode)){
      countryCode = DropdownValueService.defaultRegion;
    }

    if (DropdownValueService.stateValues.length <= 0 || countryCode !== DropdownValueService.stateRegion) {
      return DropdownValueService.regionalService.getRegionalMasks(countryCode)
        .pipe(map(res => {
          DropdownValueService.stateValues = [];
          DropdownValueService.stateValues = res.States
          DropdownValueService.stateRegion = countryCode;
          return DropdownValueService.stateValues;
        }));
    }
    return of(DropdownValueService.stateValues);
  }
  getEthnicityValues() {
    if (DropdownValueService.ethniticityValues.length <= 0) {
      return DropdownValueService.contactService.getEthnicityValues().pipe(map(res => {
        const arry = res as Array<any>;
        arry.forEach(s => {
          DropdownValueService.ethniticityValues.push({ label: s.Key, value: s.Value });
        });
        return DropdownValueService.ethniticityValues;
      }));
    }
    return of(DropdownValueService.ethniticityValues);
  }
  getAddressTypes(contactType: string) {
    if (DropdownValueService.addressTypes.length <= 0) {
      // Getting contactType from store
      if (!contactType) {
        DropdownValueService.store.select(selectContact).pipe(map(resp => resp)).subscribe(storedContacts => {
          if (storedContacts) {
            contactType = storedContacts.Type;
          }
        });
      }
      return DropdownValueService.addressService.getAddressTypes(contactType).pipe(map(res => {
        DropdownValueService.addressTypes.length = 0;
        const arry = res as Array<string>;
        arry.forEach(s => {
          DropdownValueService.addressTypes.push({ label: s, value: s });
        });

        return DropdownValueService.addressTypes;
      }));
    }
    return of(DropdownValueService.addressTypes);
  }
  getSecurityQuestionTemplates(): Observable<SelectItem[]> {
    return of(DropdownValueService.securityTemplates);
  }
  getGenderIdentityValue() {
    if (DropdownValueService.genderIds.length <= 0) {
      return DropdownValueService.contactService.getGenderList().pipe(map(res => {
        const arry = res as Array<any>;
        arry.forEach(s => {
          DropdownValueService.genderIds.push({ label: s, value: s });
        });
        return DropdownValueService.genderIds;
      }));
    }
    return of(DropdownValueService.genderIds);
  }

  getSubdivisionValues() {
    //TODO: The input 'ShowType' must be retrieved from the dropdown list control. This needs to be developed when working for HER-2550 ACA Admin part. So hard coding to 0 for now

    if (DropdownValueService.subdivisionValues.length <= 0) {
      return DropdownValueService.addressService.getSubdivisionValues(0).pipe(map(res => {
        DropdownValueService.subdivisionValues = [];
        Object.keys(res).forEach(s => {
          DropdownValueService.subdivisionValues.push({ label: res[s].Key, value: res[s].Value });
        });
        return DropdownValueService.subdivisionValues;
      }));
    }
    return of(DropdownValueService.subdivisionValues);
  }
}
